import React from "react";

import { makeStyles } from "../../shared/materials/helper";
import ChallanAvatar from "../../shared/materials/ChallanAvatar";

import EditUser from "./EditUser";
import ChallanMenu from "../../shared/materials/Menu/ChallanMenu";
import { settingsUser } from "../../../data/metadata/menuMetaData";
import Confirm from "../../shared/materials/Dialog/Confirm";
import ChangePassword from "./ChangePassword";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: theme.spacing(0, 3, 3, 0),
    boxShadow: "0px 4px 16px rgba(176, 41, 101, 0.08)",
    width: "calc(25% - 24px)",
    height: 280,
    borderRadius: "12px",
  },
  imageWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  info: {
    color: "#362B73",
  },
  name: {
    fontWeight: 600,
    fontSize: 16,
  },
  email: {
    fontWeight: 500,
    fontSize: 12,
  },
  action: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

export default function SingleUser({
  userInfo,
  updateUser,
  deleteUser,
  updatePassword,
}) {
  const classes = useStyles();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [user, setUser] = React.useState(userInfo);
  const [open, setOpen] = React.useState(false);
  const [changePasswordModal, setChangePasswordModal] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const onUserInfoChange = (id) => (event) => {
    setUser({ ...user, [id]: event.target.value });
  };

  const onUserInfoUpdate = async () => {
    const body = Object.entries(user).reduce((prev, [key, value]) => {
      if (value) prev[key] = value;

      return prev;
    }, {});

    return await updateUser(body);
  };

  const onUserDelete = () => {
    setOpen(true);
  };

  const onConfirmDelete = () => {
    deleteUser(user);
    setOpen(false);
  };

  const onUserReactivate = () => {
    setOpen(true);
  };

  const onConfirmReactivate = () => {
    updateUser({ username: user.username, active: true });
    setOpen(false);
  };

  const changePassword = (flag) => {
    setChangePasswordModal(flag);
  };

  const handleChangePassword = (password) => {
    return updatePassword(
      {
        password,
      },
      user.username
    );
  };

  React.useEffect(() => {
    setUser(userInfo);
  }, [userInfo]);

  return (
    <div className={classes.container}>
      <Confirm
        title={`${user.active ? "De" : "Re"}activate user`}
        content={`Are you sure you want to ${
          user.active ? "de" : "re"
        }activate ${user.name}?`}
        open={open}
        onClose={handleClose}
        onConfirm={userInfo.active ? onConfirmDelete : onConfirmReactivate}
      />
      <ChangePassword
        state={changePasswordModal}
        setState={changePassword}
        onUpdate={handleChangePassword}
      />
      <div className={classes.imageWrapper}>
        <ChallanAvatar username={userInfo.name} radius={96} />
      </div>
      <div className={classes.info}>
        <h1 className={classes.name}>{userInfo.name}</h1>
        <p className={classes.email}>{userInfo.username}</p>
      </div>
      <div className={classes.action}>
        <EditUser
          userInfo={user}
          onChange={onUserInfoChange}
          onUpdate={onUserInfoUpdate}
        />
        <ChallanMenu
          settings={settingsUser(userInfo.active)(
            userInfo.active ? onUserDelete : onUserReactivate,
            () => changePassword(true)
          )}
          handleOpenUserMenu={handleOpenUserMenu}
          anchorElUser={anchorElUser}
          handleCloseUserMenu={handleCloseUserMenu}
          deleteUser={deleteUser}
        />
      </div>
    </div>
  );
}
